/**
 * @author Jas, Dhaliwal
 * @email 83673@global.ul.com
 * @create date 2021-05-07
 * @desc [To implement details of story 168711 (Product Classification)]
 */
<template>
  <div class="row m-0">
    <div class="col-md-12 col-lg-12 col-sm-12 p-0">
      <div class="p-0 col-xs-12 first_table" v-if="servicesList.length">
        <table class="table activity-tracker-table">
          <thead>
            <tr>
              <th class="filter-th wd-65 sticky"></th>
              <template v-for="header in tableHeaders">
                <th v-if="header !== 'plan_id'"
                  :key="header"
                  @click="sortBy(header)"
                  :class="{ 'w-35': header==='name' }">
                  {{ header | capitalize }}
                  <span  class="arrow" :class="sortOrders[header]>0?'asc':'dsc'"></span>
                </th>
              </template>
            </tr>
          </thead>
          <tbody>
          <tr v-for="(service,index) in servicesList"
              :key="service.id">
            <td class="menu-td sticky">
              <div v-if="!service.upgraded" :id="'trackerActionDots'+index" class="dropdown dropdown-export export-activity-menu text-center">
                <div data-toggle="dropdown" style="margin-top:1px;">
                  <span class="dropdown-toggle">
                    <i class="fa fa-ellipsis-v menu-dots"></i>
                  </span>
                </div>
                <ul class="activitytrackermenu dropdown-menu export-menu" :disabled="service.upgraded">
                  <li @click="displayProdClassUpgradeOptions(service)">
                    <a class="text-color-blue menu-dots-links">
                      <span>Upgrade To Expert Review</span>
                    </a>
                  </li>
                </ul>
              </div>
            </td>
                <td>
                  {{service.report}}
                </td>
                <td>
                  {{service.market}}
                </td>
                <td>
                  {{service.classification}}
                </td>
                <td>
                  {{service.date_created | dateFormatter}}
                </td>
                <td>
                  <img v-if="service.upgraded" src="/static/images/icons/check.svg" class="image-size" alt="check-icon"/>
                </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="norecords_wrapper p-20">
        <div class="no-records-found">No Records Found</div>
      </div>
      <product-classification-report-upgrade-modal :headerId="rationaleRepId"></product-classification-report-upgrade-modal>
      <loader :loadingStatus="loaderStatus"></loader>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import moment from 'moment';
import { orderBy } from 'lodash';
import EventBus from '../../utils/event-bus';
import Loader from '../UIComponents/Loader.vue';
import { getClassificationRationaleData } from '../../apis/prodClassification';
import ProductClassificationReportUpgradeModal from './ProductClassificationReportUpgradeModal.vue';

export default {
  components: { Loader, ProductClassificationReportUpgradeModal },
  data() {
    return {
      rationaleRepId: 0,
      loaderStatus: false,
      servicesList: [],
      tableHeaders: ['Report', 'Market', 'Classification', 'Date Created', 'Upgraded'],
      sortKey: '',
      sortOrders: {},
    };
  },
  filters: {
    dateFormatter(date) {
      return date ? moment(date).format('DD/MM/YYYY') : '';
    },
    capitalize(value) {
      if (!value) return '';
      const returnVal = value.replace(/_/g, ' ').toString();
      return returnVal
        .toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');
    },
  },

  methods: {
    displayProdClassUpgradeOptions(serviceDtl) {
      this.rationaleRepId = serviceDtl.rationale_header_id;
      $('#prodClassRepUpgradeModal').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    async getServices() {
      this.loaderStatus = true;
      const accountId = sessionStorage.getItem('getAccountDetailsId');
      const response = await getClassificationRationaleData(accountId);
      this.loaderStatus = false;
      if (response.status_code !== 200) {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to fetch services',
          group: 'custom-notification',
        });
      } else {
        this.servicesList = response.data;
        // this.tableHeaders = this.servicesList.length ? Object.keys(this.servicesList[0]) : [];
      }
    },

    sortBy(sortHeader) {
      this.sortKey = sortHeader;
      this.sortOrders[sortHeader] *= -1;
      const order = this.sortOrders[sortHeader] > 0 ? 'asc' : 'desc';
      this.servicesList = orderBy(this.servicesList, [sortHeader], [order]);
    },

    setDefaultSortValues() {
      this.sortOrders = this.tableHeaders.reduce((acc, header) => {
        acc[header] = 1;
        return acc;
      }, {});
    },

    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
  },
  async created() {
    await this.getServices();
    this.setDefaultSortValues();
  },
  async mounted() {
    EventBus.$on('upgraded', () => {
    });
  },
};
</script>
<style scoped>
.image-size{
  vertical-align: sub;
}
.activity-tracker-table.table > tbody > tr > td,
.activity-tracker-table.table > thead > tr > th {
  padding-left : 15px !important;
}
.activity-tracker-table.table > tbody > tr.greyout > td{
  color:rgb(0,0,0,0.4);
}
.w-35 {
  width: 35%;
}
.w-6 {
  width: 6%;
}
.first_table th:hover .arrow {
  opacity: 0.5;
}
.first_table .arrow.asc {
  border-bottom: 6px solid #BDBDBD;
}
.first_table .arrow.dsc {
  border-top: 6px solid #BDBDBD;
}
.norecords_wrapper {
  background-color: #f9f9f9;
}
.image-size {
  height: 18px;
  width: 18px;
}
@media screen and (max-width: 767px){
  .activity-tracker-table.table  tr .sticky{
    box-shadow: 4px 0 4px -4px rgba(0, 0, 0, 0.1);
  }
}
</style>
